const LOGIN = '/crm/login/'
const LOGOUT = '/crm/logout/'
const ORDERS = '/crm/orders/'
const COMPANIES = '/companies/'
const BRANCHES = '/branch/'
const CLIENTS = '/crm/clients/'
const BONUS_LEVEL = '/users/bonus/levels/'
const SEARCH_CLIENT = '/crm/orders/searchClient/'
const DELIVERY_SLOTS = '/orders/deliverySlots/'
const SEARCH_PRODUCT = '/searchProduct/'
const LOGS = '/crm/logs/'
const CLIENT_HEADER_INFO = '/headerInfo/'
const EDIT_BONUS = '/crm/clients/bonus/'
const ROLES = '/crm/users/roles/'
const USERS = '/crm/users/'
const CREATE_USER = '/crm/users/create/'
const PAYMENT_METHODS = '/payment-methods/'
const DELIVERY_PRICE = '/crm/orders/deliveryPrice/'
const VALIDATE_PRODUCTS = '/crm/orders/validateProducts/'
const CLIENTS_ANALYTICS = '/crm/analytics/clients/'
const DOWNLOAD_CLIENTS_ANALYTICS = '/crm/analytics/clients/download-client-csv/'
const CATEGORIES = '/crm/category/'
const PRODUCTS = '/crm/product/'
const FINANCE_ANALYTICS = '/crm/analytics/finance/'
const LOYALTY_PROGRAM = '/crm/analytics/bonus/'
const DELIVERY = '/crm/analytics/delivery/'
const BRANCH = '/crm/analytics/branch/'
const GCK = '/crm/analytics/clients/lifecycle/'
const DOWNLOAD_CLIENTS = '/crm/clients/download-client-csv/'
const SATISFACTION = '/crm/analytics/nps/'
const DONWLOAD_FINANCIAL_METRICS =
  '/crm/analytics/finance/download-finance-metrics/'
const DOWNLOAD_BONUS_METRICS = '/crm/analytics/bonus/download-bonus-metrics/'
const DOWNLOAD_NPS = '/crm/analytics/nps/download-nps-csv/'
const DOWNLOAD_BRANCH = '/crm/analytics/branch/download-branch-csv/'
const DOWNLOAD_DELIVERY = '/crm/analytics/delivery/download-delivery-metrics/'
const DOWNLOAD_GCK = '/crm/analytics/clients/download-client-lifecycle/'
const APP_INTERACTION = '/crm/analytics/apps/'
const MENU_BY_MONTH = '/crm/analytics/menuByMonth/'
const USER_ACTIONS = '/crm/logs/logAction/'
const DOWNLOAD_APP_INTERACTION = '/crm/analytics/download-app-interaction-csv/'
const DOWNLOAD_MENU = '/crm/analytics/menuByMonth/download-menu-by-month-csv/'
const MENU_METRICS = '/crm/analytics/menu/'
const DOWNLOAD_MENU_METRICS = '/crm/analytics/menu/download-menu-metrics-csv/'
const CHANGE_ORDERS_VIEW = '/crm/orders/orderViewHistory/'
const UNVIEWED_ORDERS = '/crm/orders/orderViewHistoryCount/'
const CREATE_FOLDER = '/crm/wiki/folder/'
const CREATE_FILE = '/crm/wiki/file/'
const MODULES = '/crm/users/getModules/'
const NOTIFICATIONS_COUNT = '/crm/notifications/count/'
const NOTIFICATIONS = '/crm/notifications/'
const NOTIFICATIONS_SEEN = '/crm/notifications/seen/'

export const apiEndpoints = {
  login: LOGIN,
  orders: ORDERS,
  companies: COMPANIES,
  branches: BRANCHES,
  logout: LOGOUT,
  clients: CLIENTS,
  bonusLevel: BONUS_LEVEL,
  searchClient: SEARCH_CLIENT,
  deliverySlots: DELIVERY_SLOTS,
  searchProduct: SEARCH_PRODUCT,
  logs: LOGS,
  clientHeaderInfo: CLIENT_HEADER_INFO,
  editBonus: EDIT_BONUS,
  roles: ROLES,
  users: USERS,
  createUser: CREATE_USER,
  paymentMethods: PAYMENT_METHODS,
  deliveryPrice: DELIVERY_PRICE,
  validateProducts: VALIDATE_PRODUCTS,
  clientsAnalytics: CLIENTS_ANALYTICS,
  downloadClientsAnalytics: DOWNLOAD_CLIENTS_ANALYTICS,
  categories: CATEGORIES,
  products: PRODUCTS,
  financeAnalytics: FINANCE_ANALYTICS,
  loyaltyProgram: LOYALTY_PROGRAM,
  delivery: DELIVERY,
  branch: BRANCH,
  gck: GCK,
  downloadClients: DOWNLOAD_CLIENTS,
  satisfaction: SATISFACTION,
  donwloadFinancialMetrics: DONWLOAD_FINANCIAL_METRICS,
  downloadBonusMetrics: DOWNLOAD_BONUS_METRICS,
  downloadNps: DOWNLOAD_NPS,
  downloadBranch: DOWNLOAD_BRANCH,
  downloadDelivery: DOWNLOAD_DELIVERY,
  downloadGck: DOWNLOAD_GCK,
  appInteraction: APP_INTERACTION,
  menuByMonth: MENU_BY_MONTH,
  userActions: USER_ACTIONS,
  downloadAppInteraction: DOWNLOAD_APP_INTERACTION,
  downloadMenu: DOWNLOAD_MENU,
  downloadMenuMetrics: DOWNLOAD_MENU_METRICS,
  menuMetrics: MENU_METRICS,
  changeOrdersView: CHANGE_ORDERS_VIEW,
  unviewedOrders: UNVIEWED_ORDERS,
  createFolder: CREATE_FOLDER,
  createFile: CREATE_FILE,
  modules: MODULES,
  notificationsCount: NOTIFICATIONS_COUNT,
  notifications: NOTIFICATIONS,
  notificationsSeen: NOTIFICATIONS_SEEN,
}
